import firebase from "firebase";
import "firebase/firestore";
import "firebase/storage";

// firebase init goes here
var config = {
  apiKey: "AIzaSyCJSr6pJuQkvtyYTnF84DPbiTMPVybLgC4",
  authDomain: "pdx-img.firebaseapp.com",
  databaseURL: "https://pdx-img.firebaseio.com",
  projectId: "pdx-img",
  storageBucket: "pdx-img.appspot.com",
  messagingSenderId: ""
};

// var config = {
//   apiKey: "AIzaSyAzkubXXOHUZobMYuV9wanGhSHfgb7he74",
//   authDomain: "dahlphoto-f89e5.firebaseapp.com",
//   databaseURL: "https://dahlphoto-f89e5.firebaseio.com",
//   projectId: "dahlphoto-f89e5",
//   storageBucket: "dahlphoto-f89e5.appspot.com",
//   messagingSenderId: "1061703683714"
// };
firebase.initializeApp(config);

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
const currentUser = auth.currentUser;
const storage = firebase.storage();

// firebase collections
const uploads = db.collection("uploads");
const settings = db.collection("settings");
const about = db.collection("about");

export { db, auth, storage, currentUser, uploads, settings, about };
